var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icona",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_3",
    "data-name": "Ellisse 3",
    cx: 0.879,
    cy: 0.879,
    r: 0.879,
    transform: "translate(8.121 12.428)",
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_17",
    "data-name": "Tracciato 17",
    d: "M9,0a9,9,0,1,0,9,9A9,9,0,0,0,9,0ZM9,16.594A7.594,7.594,0,1,1,16.594,9,7.59,7.59,0,0,1,9,16.594Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_18",
    "data-name": "Tracciato 18",
    d: "M178.813,128.5A2.816,2.816,0,0,0,176,131.313a.7.7,0,0,0,1.406,0,1.406,1.406,0,1,1,1.406,1.406.7.7,0,0,0-.7.7v1.758a.7.7,0,0,0,1.406,0v-1.144a2.813,2.813,0,0,0-.7-5.536Z",
    transform: "translate(-169.813 -123.982)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.bdfbf4286b30cf68d1c9d1d29033dcf5.svg";
export { ForwardRef as ReactComponent };